import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { CoursePage } from '@features/groups/components/pages/CoursePage'
import { courseQueryOptions, groupsQueryOptions } from '@features/groups/queries'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/$courseId/')({
    component: RouteComponent,
    loader: async ({ params, context }) => {
        context.queryClient.ensureQueryData(courseQueryOptions({ mode: 'id', id: params.courseId }))
        context.queryClient.ensureQueryData(groupsQueryOptions({ mode: 'id', identifier: params.courseId, type: 'class' }))
        return null
    }
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load course'>
            <Suspense fallback={<LoadingIndicator resource='course' />}>
                <CoursePage mode='id' navMode='my' id={Route.useParams().courseId} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
